import React, { useEffect, useState } from "react";
import { Award, ShieldOff, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";
import StatusBadge from "../components/StatusBadge";
import { useToast } from "../hooks/use-toast";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6 ${className}`}>{children}</div>;
}

export default function Certificates() {
  const { toast } = useToast();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/certificates").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const revoke = async (uid, name) => {
    await api.post(`/admin/certificates/${uid}/revoke`);
    toast({ title: "Certificate revoked", description: `${name} is no longer certified.` });
    load();
  };

  const regenerate = async (uid, name) => {
    await api.post(`/admin/certificates/${uid}/regenerate`);
    toast({ title: "Certificate re-issued", description: `${name}'s certificate has been regenerated.` });
    load();
  };

  return (
    <div className="space-y-6">
      <Card>
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-violet-100"><Award className="h-5 w-5 text-violet-600" /></div>
          <div>
            <h2 className="text-base font-bold text-slate-900">Certificate Manager</h2>
            <p className="text-sm text-slate-500">{rows.length} certified Customer Service Representative(s).</p>
          </div>
        </div>
      </Card>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-100 text-left text-xs uppercase tracking-wide text-slate-400">
                <th className="py-2 pr-4">Name</th><th className="py-2 pr-4">Email</th><th className="py-2 pr-4">Score</th><th className="py-2 pr-4">Date</th><th className="py-2 pr-4">Client Ready</th><th className="py-2 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.user_id} className="border-b border-slate-50">
                  <td className="py-3 pr-4 font-medium text-slate-800">{r.name}</td>
                  <td className="py-3 pr-4 text-slate-600">{r.email}</td>
                  <td className="py-3 pr-4 text-slate-800">{r.score}%</td>
                  <td className="py-3 pr-4 text-slate-600">{r.date}</td>
                  <td className="py-3 pr-4">{r.client_ready ? <StatusBadge status="Approved" /> : <StatusBadge status="Pending" />}</td>
                  <td className="py-3 text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button size="sm" variant="outline" onClick={() => regenerate(r.user_id, r.name)} data-testid={`regenerate-${r.user_id}`} className="gap-1.5"><RefreshCw className="h-3.5 w-3.5" /> Regenerate</Button>
                      <Button size="sm" variant="outline" onClick={() => revoke(r.user_id, r.name)} data-testid={`revoke-${r.user_id}`} className="gap-1.5 border-rose-200 text-rose-600 hover:bg-rose-50"><ShieldOff className="h-3.5 w-3.5" /> Revoke</Button>
                    </div>
                  </td>
                </tr>
              ))}
              {rows.length === 0 && (<tr><td colSpan={6} className="py-8 text-center text-slate-400">No certified agents yet.</td></tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
